import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'

import CommunicationItem from '@app/application/communication/sections/communication/components/communication-item'
import createStore from '@app/application/communication/sections/communication/store'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='communication-item']").each(function () {
    const data = $(this).data()
    const endpointParams = {
      communicationItemId: data.communicationItemId,
      communicationItemType: data.communicationItemType,
    }
    const store = createStore(endpointParams)

    const communicationItemApp = createApp(CommunicationItem)
    communicationItemApp.use(store)
    communicationItemApp.mount(this)
  })
})
